import { env } from '../env'
/**
 * Here goes the global constants
 */
export const APPLICATION_ID = env.REACT_APP_ID_BOUTIQUE;
export const APP_NAME = 'eBuyClub';
export const BRAND_NAME = 'eBuyClub';
export const COMPANY_NAME = 'eBuyClub';
export const APP_TITLE = `${BRAND_NAME} - `;
export const APP_DESCRIPTION = 'eBuyClub - Koop slimmer';
export const DOMAIN_COOKIE = env.REACT_APP_DOMAIN_COOKIE;
export const CONTEXT_ROOT = env.REACT_APP_CONTEXT_ROOT;
export const API_ROOT =
    env.REACT_APP_API_ROOT || `${env.REACT_APP_CONTEXT_ROOT}/api`;
export const STATIC_ROOT = env.REACT_APP_STATIC_ROOT;
export const LARGE_LOGO_ROOT = env.REACT_APP_LARGE_LOGO_ROOT;
export const LOGO_ROOT = env.REACT_APP_LOGO_ROOT;
export const STATIC_CMS_ROOT = env.REACT_APP_STATIC_CMS_ROOT;
export const URL_PAGE_FACEBOOK = '';
export const URL_PAGE_TWITTER = '';
export const URL_PAGE_GOOGLEPLUS = '';

export const PAYMENT_THRESHOLD = 10;

export const IS_DEV = env.NODE_ENV === 'development';
export const IS_STAGING = env.REACT_APP_PROFILE === 'preproduction';
export const IS_PROD = env.NODE_ENV === 'production';

export const DATE_FORMAT_REDUXFORM = 'yyyy-mm-dd';

// action input reduxform change
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';

export const TIMER_MS_INTERSTITIEL = 5500;

export const FAQ_ID_WHY_CASHBACK_INVALIDATED =
    env.REACT_APP_FAQ_ID_WHY_CASHBACK_INVALIDATED || null;

export const CONTACT_REQUEST_REASON_ID_COMPLAINT =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_COMPLAINT || null;

export const MY_POT_MOST_COMMON_QUESTIONS = env.REACT_APP_MY_POT_MOST_COMMON_QUESTIONS;

export const GA_TRACKING_NUMBER = env.REACT_APP_GA_TRACKING_NUMBER;

export const DIDOMI_PUBLIC_API_KEY = env.REACT_APP_DIDOMI_PUBLIC_API_KEY;
export const DIDOMI_NOTICE_ID = env.REACT_APP_DIDOMI_NOTICE_ID;
export const DIDOMI_VENDOR_GOOGLE_ID = env.REACT_APP_DIDOMI_VENDOR_GOOGLE_ID;



// WEBPACK FOOTER //
// ./src/constants/index.js